import type { FC, SVGProps } from 'react';
import Number00 from './Number00';
import Number01 from './Number01';
import Number02 from './Number02';
import Number03 from './Number03';
import Number04 from './Number04';
import Number05 from './Number05';
import Number06 from './Number06';
import Number07 from './Number07';
import Number08 from './Number08';
import Number09 from './Number09';
import Number10 from './Number10';
import Number11 from './Number11';
import Number12 from './Number12';
import Number13 from './Number13';
import Number14 from './Number14';
import Number15 from './Number15';
import Number16 from './Number16';
import Number17 from './Number17';
import Number18 from './Number18';
import Number19 from './Number19';
import Number20 from './Number20';

const NumberGlyphs: FC<SVGProps<SVGSVGElement>>[] = [
  Number00, Number01, Number02, Number03, Number04,
  Number05, Number06, Number07, Number08, Number09,
  Number10, Number11, Number12, Number13, Number14,
  Number15, Number16, Number17, Number18, Number19,
  Number20,
];

export default NumberGlyphs;
